import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { useDispatch } from '@app/hooks';

import { resetState } from '../slice';

export const useStoreReset = () => {
  const { pathname } = useLocation();
  const pathChanged = useRef(false);
  const dispatch = useDispatch();

  const resetStore = () => {
    pathChanged.current = true;
  };

  useEffect(() => {
    if (pathChanged.current) {
      dispatch(resetState());
      pathChanged.current = false;
    }
  }, [pathname, dispatch]);

  return { resetStore };
};
